<ul class="flex flex-col pt-3 gap-2 px-2 pb-2 overflow-y-auto max-h-[60vh] sm:pb-0 sm:mb-0 sm:px-0 mt-2">
  @for (lagerplatz of data(); track $index) {
    <li
      class="py-2 group px-2.5 flex flex-col bg-surface shadow-sm hover:shadow hover:border-primary rounded border hover:bg-hover hover:cursor-pointer"
      (click)="resolve(lagerplatz.lagerplatz)"
    >
      <div class="flex items-center justify-between">
        <span class="font-semibold inline-block pb-1">{{
          lagerplatz.lagerplatz?.lagerplatz ?? '-'
        }}</span>

        <span class="text-lighter">
          <soft-icon name="fa-regular fa-chevron-right text-xs"></soft-icon>
        </span>
      </div>

      <div
        class="flex items-center justify-between border-t border-t-border group-hover:border-t-transparent pt-1"
      >
        <div class="flex flex-col">
          <span class="text-sm text-light">Menge</span>
          <span class="text-sm text-light">Lagermenge</span>
        </div>

        <div class="flex flex-col items-end justify-end text-right">
          <span class="text-sm text-light text-right"
            >{{ lagerplatz.menge }} {{ lagerplatz?.einheit?.arteh }}</span
          >
          <span class="text-sm text-light text-right"
            >{{ lagerplatz.mengeLager }} {{ lagerplatz?.einheitLager?.arteh }}</span
          >
        </div>
      </div>
    </li>
  }

  <li
    (click)="resolve('ALL_STORAGE_LOCATIONS')"
    class="py-2 px-2.5 flex items-center justify-between bg-surface shadow-sm hover:shadow rounded border hover:bg-hover hover:border-primary hover:cursor-pointer"
  >
    <div class="flex items-center justify-start gap-2">
      <soft-icon name="fa-regular fa-shelves" class="text-3xl ml-1 pr-1 "></soft-icon>

      <div class="flex flex-col">
        <span class="text-base font-semibold">Alle Lagerplätze anzeigen</span>
        <span class="text-sm text-light">Auswahl aus allen verfügbaren Lagerplätzen</span>
      </div>
    </div>

    <span class="text-lighter">
      <soft-icon name="fa-regular fa-chevron-right text-base"></soft-icon>
    </span>
  </li>
</ul>
